// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.weather-container {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    padding: 30px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    max-width: 500px;
    width: 100%;
    text-align: center;
}

.title {
    color: #333;
    margin-bottom: 30px;
    font-size: 2.5rem;
    font-weight: 300;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.city-selector {
    margin-bottom: 30px;
}

.city-selector label {
    display: block;
    margin-bottom: 10px;
    color: #666;
    font-weight: 500;
}

.city-selector select {
    padding: 12px 20px;
    border: 2px solid #e1e5e9;
    border-radius: 10px;
    font-size: 16px;
    background: white;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 200px;
}

.city-selector select:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.weather-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    padding: 30px;
    color: white;
    margin-bottom: 30px;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.weather-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.weather-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
}

.weather-info {
    text-align: right;
    flex: 1;
}

.city-name {
    margin: 0 0 10px 0;
    font-size: 1.8rem;
    font-weight: 300;
}

.temperature {
    margin-bottom: 15px;
}

.temp-value {
    font-size: 3rem;
    font-weight: 200;
    display: block;
}

.condition {
    font-size: 1.2rem;
    margin-bottom: 20px;
    opacity: 0.9;
}

.details {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 20px;
}

.detail-item {
    text-align: center;
}

.label {
    display: block;
    font-size: 0.9rem;
    opacity: 0.8;
    margin-bottom: 5px;
}

.value {
    display: block;
    font-size: 1.1rem;
    font-weight: 500;
}

/* API测试区域样式 */
.api-test-section {
    background: #f8f9fa;
    border-radius: 15px;
    padding: 25px;
    margin-bottom: 30px;
    text-align: center;
}

.api-test-section h3 {
    color: #333;
    margin-bottom: 20px;
    font-size: 1.3rem;
}

.api-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.api-btn {
    padding: 12px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.api-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.api-btn:active {
    transform: translateY(0);
}

.api-status {
    background: #e8f5e8;
    border: 1px solid #4caf50;
    border-radius: 8px;
    padding: 15px;
    margin-top: 15px;
}

.api-status p {
    color: #2e7d32;
    margin: 0;
    font-weight: 500;
}

.features {
    background: #f8f9fa;
    border-radius: 15px;
    padding: 25px;
    text-align: left;
}

.features h3 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.3rem;
    text-align: center;
}

.features ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.features li {
    padding: 8px 0;
    color: #666;
    font-size: 1rem;
    border-bottom: 1px solid #eee;
}

.features li:last-child {
    border-bottom: none;
}

.loading {
    text-align: center;
    color: white;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* 响应式设计 */
@media (max-width: 600px) {
    .weather-container {
        padding: 20px;
        margin: 10px;
    }

    .title {
        font-size: 2rem;
    }

    .weather-card {
        padding: 15px;
    }

    .temp-value {
        font-size: 3rem;
    }

    .details {
        flex-direction: column;
        gap: 15px;
    }

    .api-buttons {
        flex-direction: column;
        align-items: center;
    }

    .api-btn {
        width: 100%;
        max-width: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,UAAU;AACV;IACI;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".app {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 20px;\r\n}\r\n\r\n.weather-container {\r\n    background: rgba(255, 255, 255, 0.95);\r\n    border-radius: 20px;\r\n    padding: 30px;\r\n    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\r\n    backdrop-filter: blur(10px);\r\n    max-width: 500px;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.title {\r\n    color: #333;\r\n    margin-bottom: 30px;\r\n    font-size: 2.5rem;\r\n    font-weight: 300;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n}\r\n\r\n.city-selector {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.city-selector label {\r\n    display: block;\r\n    margin-bottom: 10px;\r\n    color: #666;\r\n    font-weight: 500;\r\n}\r\n\r\n.city-selector select {\r\n    padding: 12px 20px;\r\n    border: 2px solid #e1e5e9;\r\n    border-radius: 10px;\r\n    font-size: 16px;\r\n    background: white;\r\n    color: #333;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    min-width: 200px;\r\n}\r\n\r\n.city-selector select:focus {\r\n    outline: none;\r\n    border-color: #667eea;\r\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\r\n}\r\n\r\n.weather-card {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 15px;\r\n    padding: 30px;\r\n    color: white;\r\n    margin-bottom: 30px;\r\n    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.weather-box {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.weather-icon {\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.weather-info {\r\n    text-align: right;\r\n    flex: 1;\r\n}\r\n\r\n.city-name {\r\n    margin: 0 0 10px 0;\r\n    font-size: 1.8rem;\r\n    font-weight: 300;\r\n}\r\n\r\n.temperature {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.temp-value {\r\n    font-size: 3rem;\r\n    font-weight: 200;\r\n    display: block;\r\n}\r\n\r\n.condition {\r\n    font-size: 1.2rem;\r\n    margin-bottom: 20px;\r\n    opacity: 0.9;\r\n}\r\n\r\n.details {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    flex-wrap: wrap;\r\n    gap: 20px;\r\n}\r\n\r\n.detail-item {\r\n    text-align: center;\r\n}\r\n\r\n.label {\r\n    display: block;\r\n    font-size: 0.9rem;\r\n    opacity: 0.8;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.value {\r\n    display: block;\r\n    font-size: 1.1rem;\r\n    font-weight: 500;\r\n}\r\n\r\n/* API测试区域样式 */\r\n.api-test-section {\r\n    background: #f8f9fa;\r\n    border-radius: 15px;\r\n    padding: 25px;\r\n    margin-bottom: 30px;\r\n    text-align: center;\r\n}\r\n\r\n.api-test-section h3 {\r\n    color: #333;\r\n    margin-bottom: 20px;\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.api-buttons {\r\n    display: flex;\r\n    gap: 15px;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.api-btn {\r\n    padding: 12px 24px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.api-btn:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n.api-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n.api-status {\r\n    background: #e8f5e8;\r\n    border: 1px solid #4caf50;\r\n    border-radius: 8px;\r\n    padding: 15px;\r\n    margin-top: 15px;\r\n}\r\n\r\n.api-status p {\r\n    color: #2e7d32;\r\n    margin: 0;\r\n    font-weight: 500;\r\n}\r\n\r\n.features {\r\n    background: #f8f9fa;\r\n    border-radius: 15px;\r\n    padding: 25px;\r\n    text-align: left;\r\n}\r\n\r\n.features h3 {\r\n    color: #333;\r\n    margin-bottom: 15px;\r\n    font-size: 1.3rem;\r\n    text-align: center;\r\n}\r\n\r\n.features ul {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.features li {\r\n    padding: 8px 0;\r\n    color: #666;\r\n    font-size: 1rem;\r\n    border-bottom: 1px solid #eee;\r\n}\r\n\r\n.features li:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.loading {\r\n    text-align: center;\r\n    color: white;\r\n}\r\n\r\n.spinner {\r\n    width: 50px;\r\n    height: 50px;\r\n    border: 4px solid rgba(255, 255, 255, 0.3);\r\n    border-top: 4px solid white;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n    margin: 0 auto 20px;\r\n}\r\n\r\n@keyframes spin {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n/* 响应式设计 */\r\n@media (max-width: 600px) {\r\n    .weather-container {\r\n        padding: 20px;\r\n        margin: 10px;\r\n    }\r\n\r\n    .title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .weather-card {\r\n        padding: 15px;\r\n    }\r\n\r\n    .temp-value {\r\n        font-size: 3rem;\r\n    }\r\n\r\n    .details {\r\n        flex-direction: column;\r\n        gap: 15px;\r\n    }\r\n\r\n    .api-buttons {\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n\r\n    .api-btn {\r\n        width: 100%;\r\n        max-width: 200px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
